var map = {
	"./subnav.de-CH.json": 1487,
	"./subnav.de-DE.json": 1488,
	"./subnav.en-CA.json": 1489,
	"./subnav.en-GB.json": 1490,
	"./subnav.en-IN.json": 1491,
	"./subnav.en-ME.json": 1492,
	"./subnav.en-US.json": 1493,
	"./subnav.es-EM.json": 1494,
	"./subnav.es-ES.json": 1495,
	"./subnav.fr-BE.json": 1496,
	"./subnav.fr-CA.json": 1497,
	"./subnav.fr-CH.json": 1498,
	"./subnav.nl-BE.json": 1499,
	"./subnav.nl-NL.json": 1500,
	"./subnav.pl-PL.json": 1501,
	"./subnav.pt-BR.json": 1502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1486;